import { render } from "./ProjectIcons.vue?vue&type=template&id=5fd77455&scoped=true"
import script from "./ProjectIcons.vue?vue&type=script&lang=js"
export * from "./ProjectIcons.vue?vue&type=script&lang=js"

import "./ProjectIcons.vue?vue&type=style&index=0&id=5fd77455&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd77455"]])

export default __exports__